// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cb-link {
  font-weight: var(--cb-font-weight-bold);
  text-decoration: none;
  cursor: pointer;
  background-color: transparent;
  border: none;
  padding: 0;
}

.cb-primary-link {
  color: var(--cb-primary-color);
}

.cb-primary-link:hover {
  color: var(--cb-primary-color-hover);
}

.cb-primary-link .cb-disabled {
  color: var(--cb-primary-color-disabled);
}

.cb-secondary-link {
  color: var(--cb-secondary-link-color);
}

button.cb-primary-button {
  align-self: center;
  padding: 0.6rem;
  color: var(--cb-button-text-primary-color);
  background-color: var(--cb-primary-color);
  border-radius: var(--cb-border-radius-sm);
  border: none;
  width: var(--cb-container-wide-width);
  font-family: var(--cb-primary-font);
  font-weight: var(--cb-font-weight-bold);
  cursor: pointer;
  box-sizing: border-box;
  line-height: 1.25;
}

.cb-primary-button:hover,
.cb-primary-button:focus,
.cb-primary-button:active {
  background-color: var(--cb-primary-color-hover);
}

.cb-primary-button:disabled {
  background-color: var(--cb-primary-color-disabled);
}

button.cb-primary-button-error-variant {
  background-color: var(--cb-error-text-color);
}

.cb-primary-button-error-variant:hover,
.cb-primary-button-error-variant:focus,
.cb-primary-button-error-variant:active {
  background-color: #850707;
}

.cb-primary-button-error-variant:disabled {
  background-color: #f06161;
}

.cb-primary-button-spinner {
  border-top-color: var(--cb-button-text-primary-color);
  border-right-color: var(--cb-button-text-primary-color);
  width: calc(var(--cb-base-font-size) * 1.25 * 1.25);
  height: calc(var(--cb-base-font-size) * 1.25 * 1.25);
  box-sizing: border-box;
}

.cb-icon-button {
  display: flex;
  gap: 0.3rem;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 2rem;
  border: 1px solid var(--cb-border-color);
  border-radius: var(--cb-border-radius-sm);
  text-decoration: none;
  color: var(--cb-primary-text-color);
  background-color: var(--cb-white);
  font-family: var(--cb-secondary-font);
  cursor: pointer;
  padding-right: 0.5rem;
  padding-left: 0.3rem;
}

.cb-icon-button-with-icon-only {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 2rem;
  border: 1px solid var(--cb-border-color);
  border-radius: var(--cb-border-radius-sm);
  text-decoration: none;
  color: var(--cb-primary-text-color);
  background-color: var(--cb-white);
  font-family: var(--cb-secondary-font);
  cursor: pointer;
  width: 5.25rem;
  line-height: 1;
}

.cb-icon-button:hover {
  background-color: var(--cb-box-color-hover);
}

.cb-icon-button-with-icon-only:hover {
  background-color: var(--cb-box-color-hover);
}

.cb-icon-button-icon img {
  height: 1.5rem;
  vertical-align: middle;
}
`, "",{"version":3,"sources":["webpack://./src/styles/buttons.css"],"names":[],"mappings":"AAAA;EACE,uCAAuC;EACvC,qBAAqB;EACrB,eAAe;EACf,6BAA6B;EAC7B,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,0CAA0C;EAC1C,yCAAyC;EACzC,yCAAyC;EACzC,YAAY;EACZ,qCAAqC;EACrC,mCAAmC;EACnC,uCAAuC;EACvC,eAAe;EACf,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;;EAGE,+CAA+C;AACjD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,uDAAuD;EACvD,mDAAmD;EACnD,oDAAoD;EACpD,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,wCAAwC;EACxC,yCAAyC;EACzC,qBAAqB;EACrB,mCAAmC;EACnC,iCAAiC;EACjC,qCAAqC;EACrC,eAAe;EACf,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,wCAAwC;EACxC,yCAAyC;EACzC,qBAAqB;EACrB,mCAAmC;EACnC,iCAAiC;EACjC,qCAAqC;EACrC,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB","sourcesContent":[".cb-link {\n  font-weight: var(--cb-font-weight-bold);\n  text-decoration: none;\n  cursor: pointer;\n  background-color: transparent;\n  border: none;\n  padding: 0;\n}\n\n.cb-primary-link {\n  color: var(--cb-primary-color);\n}\n\n.cb-primary-link:hover {\n  color: var(--cb-primary-color-hover);\n}\n\n.cb-primary-link .cb-disabled {\n  color: var(--cb-primary-color-disabled);\n}\n\n.cb-secondary-link {\n  color: var(--cb-secondary-link-color);\n}\n\nbutton.cb-primary-button {\n  align-self: center;\n  padding: 0.6rem;\n  color: var(--cb-button-text-primary-color);\n  background-color: var(--cb-primary-color);\n  border-radius: var(--cb-border-radius-sm);\n  border: none;\n  width: var(--cb-container-wide-width);\n  font-family: var(--cb-primary-font);\n  font-weight: var(--cb-font-weight-bold);\n  cursor: pointer;\n  box-sizing: border-box;\n  line-height: 1.25;\n}\n\n.cb-primary-button:hover,\n.cb-primary-button:focus,\n.cb-primary-button:active {\n  background-color: var(--cb-primary-color-hover);\n}\n\n.cb-primary-button:disabled {\n  background-color: var(--cb-primary-color-disabled);\n}\n\nbutton.cb-primary-button-error-variant {\n  background-color: var(--cb-error-text-color);\n}\n\n.cb-primary-button-error-variant:hover,\n.cb-primary-button-error-variant:focus,\n.cb-primary-button-error-variant:active {\n  background-color: #850707;\n}\n\n.cb-primary-button-error-variant:disabled {\n  background-color: #f06161;\n}\n\n.cb-primary-button-spinner {\n  border-top-color: var(--cb-button-text-primary-color);\n  border-right-color: var(--cb-button-text-primary-color);\n  width: calc(var(--cb-base-font-size) * 1.25 * 1.25);\n  height: calc(var(--cb-base-font-size) * 1.25 * 1.25);\n  box-sizing: border-box;\n}\n\n.cb-icon-button {\n  display: flex;\n  gap: 0.3rem;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  height: 2rem;\n  border: 1px solid var(--cb-border-color);\n  border-radius: var(--cb-border-radius-sm);\n  text-decoration: none;\n  color: var(--cb-primary-text-color);\n  background-color: var(--cb-white);\n  font-family: var(--cb-secondary-font);\n  cursor: pointer;\n  padding-right: 0.5rem;\n  padding-left: 0.3rem;\n}\n\n.cb-icon-button-with-icon-only {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  height: 2rem;\n  border: 1px solid var(--cb-border-color);\n  border-radius: var(--cb-border-radius-sm);\n  text-decoration: none;\n  color: var(--cb-primary-text-color);\n  background-color: var(--cb-white);\n  font-family: var(--cb-secondary-font);\n  cursor: pointer;\n  width: 5.25rem;\n  line-height: 1;\n}\n\n.cb-icon-button:hover {\n  background-color: var(--cb-box-color-hover);\n}\n\n.cb-icon-button-with-icon-only:hover {\n  background-color: var(--cb-box-color-hover);\n}\n\n.cb-icon-button-icon img {\n  height: 1.5rem;\n  vertical-align: middle;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
